"use client"

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import {
  Calendar,
  House,
  List,
  SquareTerminal,
  Users,
} from "lucide-react"

export function NavMain({
}: {
  }) {
  const items = [
    {
      title: "Home",
      url: "/app/",
      icon: House,
      isActive: true,
    },
    // {
    //   title: "Chat",
    //   url: "/app/chat",
    //   icon: SquareTerminal,
    //   isActive: true,
    //   items: [
    //     {
    //       title: "History",
    //       url: "/app/chat/history",
    //     },
    //     {
    //       title: "Starred",
    //       url: "/app/chat/starred",
    //     },
    //   ],
    // },
    {
      title: "Records",
      url: "/app/records",
      icon: List,
      items: [
        {
          title: "Latest",
          url: "/app/records/latest",
        },
        {
          title: "Explorer",
          url: "/app/records/explorer",
        },
      ],
    },
    {
      title: "Events",
      url: "/app/events",
      icon: Calendar,
      items: [
        {
          title: "Upcoming",
          url: "/app/events/upcoming",
        },
        {
          title: "Past",
          url: "/app/events/past",
        },
      ],
    },
    {
      title: "Organisations",
      url: "/app/organisations",
      icon: Users,
    }
  ]
  return (
    <SidebarGroup>
      <SidebarGroupLabel>Platform</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarMenuButton asChild tooltip={item.title}>
              <a href={item.url} className="flex items-center w-full">
                {item.icon && <item.icon />}
                <span className="ml-2">{item.title}</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
